import type { Product } from './products';
import {
  CircleAlert,
  CircleCheckBig,
  CircleX,
  Package,
  Truck,
} from 'lucide-react';
import type {
  OrderStatus,
  PlatformProductLength,
  UnitCode,
} from '~/graphql/graphql.ts';

export interface OrderItem {
  product: Product;
  quantity: { value: number; unit: UnitCode };
  price: number;
  platformProductsLengths: PlatformProductLength;
}

export const STATUS_FLOW = [
  'PENDING_SELLER_CONFIRMATION',
  'CONFIRMED',
  'SHIPPED',
  'DELIVERED',
] as const satisfies readonly OrderStatus[];

export const STATUS_METADATA: Record<
  OrderStatus,
  {
    label: string;
    message: Record<'BUYER' | 'SELLER', string>;
    Icon: React.ComponentType<{ className?: string; size: number }>;
  }
> = {
  DRAFT: {
    label: 'order.draft_orders',
    message: {
      BUYER: 'order.buyer_order_draft',
      SELLER: 'order.seller_order_draft',
    },
    Icon: Package,
  },
  PENDING_SELLER_CONFIRMATION: {
    label: 'order.placed',
    message: {
      BUYER: 'order.pending_seller_confirmation_message',
      SELLER: 'order.pending_seller_confirmation_review',
    },
    Icon: Package,
  },
  CONFIRMED: {
    label: 'order.confirmed',
    message: {
      BUYER: 'order.buyer_order_confirmed',
      SELLER: 'order.seller_order_confirmed',
    },
    Icon: CircleCheckBig,
  },
  SHIPPED: {
    label: 'order.shipped',
    message: {
      BUYER: 'order.buyer_order_shipped',
      SELLER: 'order.seller_order_shipped_message',
    },
    Icon: Truck,
  },
  DELIVERED: {
    label: 'order.delivered',
    message: {
      BUYER: 'order.buyer_order_delivered',
      SELLER: 'order.seller_order_delivered',
    },
    Icon: CircleCheckBig,
  },
  CANCELLED: {
    label: 'order.cancelled',
    message: {
      BUYER: 'order.buyer_order_cancelled',
      SELLER: 'order.seller_order_cancelled',
    },
    Icon: CircleX,
  },
  BLOCKED: {
    label: 'order.blocked',
    message: {
      BUYER: 'order.buyer_order_blocked',
      SELLER: 'order.seller_order_blocked',
    },
    Icon: CircleAlert,
  },
};

export const STATUS_STEPS = STATUS_FLOW.map((status) => ({
  status,
  ...STATUS_METADATA[status],
}));
